document.addEventListener('DOMContentLoaded', () => {

    // 💶 Format monétaire
    /**
     * @param {number} cents
     */
    function formatMoney(cents) {
        const moneyFormat = (window.shopSettings && window.shopSettings.moneyFormat) || "{{amount_with_comma_separator}} €";
        const euros = (cents / 100).toFixed(2);
        const parts = euros.split('.');
        if (parts[0]) {
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        const formattedPrice = parts.join(','); 
      
        return `${formattedPrice} €`;
      }
  
    // 🖼️ Gestion du hover sur un swatch
    /**
     * @param {HTMLElement} swatchEl
     */
    function handleSwatchHover(swatchEl) {
      /** @type {HTMLElement | null} */
      const productCard = swatchEl.closest('.c-pdt-mini__card');
      if (!productCard) return;
  
      /** @type {HTMLImageElement | null} */
      const imageEl = productCard.querySelector('.c-pdt-mini__img img');
      /** @type {HTMLElement | null} */
      const priceEl = productCard.querySelector('.c-price, .price, .c-pdt-mini__price');
  
      // Sauvegarder l'état original si pas déjà fait
      if (imageEl && !productCard.dataset.originalImage) {
        productCard.dataset.originalImage = imageEl.src;
      }
      if (priceEl && !productCard.dataset.originalPrice) {
        productCard.dataset.originalPrice = priceEl.textContent.trim();
      }
  
      // Changement image
      const imgSrc = swatchEl.dataset.image;
      if (imgSrc && imageEl) {
        imageEl.src = imgSrc;
        imageEl.srcset = imgSrc;
      }
  
      // Changement prix
      const price = swatchEl.dataset.price;
      const productUrl = swatchEl.dataset.productUrl;
      const variantId = swatchEl.dataset.variantId;
  
      if (price && priceEl) {
        priceEl.textContent = formatMoney(Number(price));
      } else if (productUrl && variantId) {
        fetch(`${productUrl}?variant=${variantId}&view=card`)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newImg = doc.querySelector('img');
            const newPrice = doc.querySelector('.price, .c-price, .c-pdt-mini__price');
            if (newImg && imageEl) imageEl.src = newImg.src;
            if (newPrice && priceEl) priceEl.innerHTML = newPrice.innerHTML;
          })
          .catch(err => console.error('Erreur fetch swatch:', err));
      }
  
      // Classe active
      productCard.querySelectorAll('.c-swatch-hover').forEach(el => el.classList.remove('is-active'));
      swatchEl.classList.add('is-active');
    }
  
    /**
     * @param {HTMLElement} swatchEl
     */
    function handleSwatchLeave(swatchEl) {
      /** @type {HTMLElement | null} */
      const productCard = swatchEl.closest('product-card, .c-pdt-mini__card, .c-related-item');
      if (!productCard) return;
  
      /** @type {HTMLImageElement | null} */
      const imageEl = productCard.querySelector('.c-pdt-mini__img img');
      /** @type {HTMLElement | null} */
      const priceEl = productCard.querySelector('.c-price, .price, .c-pdt-mini__price');
  
      // Restaurer l'image et le prix original
      if (imageEl && productCard.dataset.originalImage) {
        imageEl.src = productCard.dataset.originalImage;
        imageEl.srcset = productCard.dataset.originalImage;
      }
      if (priceEl && productCard.dataset.originalPrice) {
        priceEl.textContent = productCard.dataset.originalPrice;
      }
  
      // Retirer la classe active
      swatchEl.classList.remove('is-active');
    }
  
    // 📌 Délégation d'événement pour tous les swatches existants et futurs
    document.body.addEventListener('mouseover', e => {
      if (!e.target || !(e.target instanceof Element)) return;
      const swatch = e.target.closest('.c-swatch-hover[data-variant-id]');
      if (!swatch || !(swatch instanceof HTMLElement)) return;
      handleSwatchHover(swatch);
    });
  
    document.body.addEventListener('mouseout', e => {
      if (!e.target || !(e.target instanceof Element)) return;
      const swatch = e.target.closest('.c-swatch-hover[data-variant-id]');
      if (!swatch || !(swatch instanceof HTMLElement)) return;
      handleSwatchLeave(swatch);
    });
  
  });
  